"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArticleStatus = exports.Article = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _clsx4 = _interopRequireDefault(require("clsx"));
var _domParser = _interopRequireDefault(require("dom-parser"));
var _sanitizeHtml = _interopRequireDefault(require("sanitize-html"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _PopupArticle = require("./PopupArticle");
var _reactSvg = require("react-svg");
var _Title = require("../Title");
var _Text = require("../Text");
var _Button = require("../Button");
var _sanitizeHtmlOptions = _interopRequireDefault(require("../../constants/sanitizeHtmlOptions"));
var _tools = require("../../utils/tools");
var _key_answer_arrow = _interopRequireDefault(require("../../assets/images/key_answer_arrow.svg"));
var _fail_to_load = _interopRequireDefault(require("../../assets/images/fail_to_load.svg"));
var _loading_circle = _interopRequireDefault(require("../../assets/images/loading_circle.svg"));
var _resizeObserver = require("@juggle/resize-observer");
var _constants = require("../../utils/constants");
var _LocaleProvider = require("../LocaleProvider");
var _useTracking = require("../../hooks/useTracking");
var _constants2 = require("../../utils/tracking/constants");
var _RichText = require("../RichText");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var ArticleStatus;
exports.ArticleStatus = ArticleStatus;
(function (ArticleStatus) {
  ArticleStatus["LOADING"] = "LOADING";
  ArticleStatus["DELETED"] = "DELETED";
  ArticleStatus["ERROR"] = "ERROR";
  ArticleStatus["FINISH"] = "FINISH";
})(ArticleStatus || (exports.ArticleStatus = ArticleStatus = {}));
var domParser = new _domParser.default();
var Article = function Article(props) {
  var _componentTrackingDat, _props$componentTrack;
  var title = props.title,
    content = props.content,
    _props$status = props.status,
    status = _props$status === void 0 ? ArticleStatus.FINISH : _props$status,
    _props$failToLoadText = props.failToLoadText,
    failToLoadText = _props$failToLoadText === void 0 ? '' : _props$failToLoadText,
    _props$reloadText = props.reloadText,
    reloadText = _props$reloadText === void 0 ? '' : _props$reloadText,
    _props$articleDeleted = props.articleDeletedText,
    articleDeletedText = _props$articleDeleted === void 0 ? '' : _props$articleDeleted,
    showButtonText = props.showButtonText,
    closeButtonText = props.closeButtonText,
    componentTrackingData = props.componentTrackingData,
    articleContentTrackingData = props.articleContentTrackingData,
    disableSpecialLink = props.disableSpecialLink,
    _props$autoPopup = props.autoPopup,
    autoPopup = _props$autoPopup === void 0 ? false : _props$autoPopup,
    _props$isSeparate = props.isSeparate,
    isSeparate = _props$isSeparate === void 0 ? false : _props$isSeparate,
    _props$isScrollToUnre = props.isScrollToUnread,
    isScrollToUnread = _props$isScrollToUnre === void 0 ? false : _props$isScrollToUnre,
    showExpandIcon = props.showExpandIcon,
    unreadText = props.unreadText,
    viewMoreText = props.viewMoreText,
    _props$summaryMaxHeig = props.summaryMaxHeight,
    summaryMaxHeight = _props$summaryMaxHeig === void 0 ? 400 : _props$summaryMaxHeig,
    faqTitle = props.faqTitle,
    faqIntentList = props.faqIntentList,
    disabledFaq = props.disabledFaq,
    onExceededMaxHeightChange = props.onExceededMaxHeightChange,
    isOldUI = props.isOldUI,
    needPopup = props.needPopup,
    useUIOptimisationRecommender = props.useUIOptimisationRecommender,
    isUIOptimisationAccordion = props.isUIOptimisationAccordion,
    isUIOptimisationButton = props.isUIOptimisationButton,
    isUIOptimisationTable = props.isUIOptimisationTable,
    popupClassName = props.popupClassName;
  var summaryRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    showArticle = _useState2[0],
    setShowArticle = _useState2[1];
  var _useState3 = (0, _react.useState)(undefined),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    exceededMaxHeight = _useState4[0],
    setExceededMaxHeight = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    firstAccordionItemLen = _useState6[0],
    setFirstAccordionItemLen = _useState6[1];
  var firstAccordionUIOptimisation = isUIOptimisationAccordion && firstAccordionItemLen >= 3;
  var _useState7 = (0, _react.useState)(),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    uiOptimisationAccordionOptions = _useState8[0],
    setUIOptimisationAccordionOptions = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
    isFirstAccordion = _useState10[0],
    setIsFirstAccordion = _useState10[1];
  var _useState11 = (0, _react.useState)({
      index: 0
    }),
    _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
    unreadObj = _useState12[0],
    setUnreadObj = _useState12[1];
  var _useLocale = (0, _LocaleProvider.useLocale)(),
    trans = _useLocale.trans;
  var trackCloseArticleContentDataRef = (0, _react.useRef)({
    startTime: new Date(),
    articleScrolls: 0,
    tableScrolls: 0,
    articleScrollToEnd: false
  });
  var changeTrackCloseArticleContentData = function changeTrackCloseArticleContentData(data) {
    var trackCloseArticleContentData = trackCloseArticleContentDataRef.current;
    trackCloseArticleContentDataRef.current = _objectSpread(_objectSpread({}, trackCloseArticleContentData), data);
  }; // 补充上报数据

  if (componentTrackingData !== null && componentTrackingData !== void 0 && (_componentTrackingDat = componentTrackingData.article) !== null && _componentTrackingDat !== void 0 && _componentTrackingDat.trackingdataBasic) {
    componentTrackingData.article.trackingdataBasic.button_text = showButtonText || trans(_constants.VIEW_ARTICLE_TEXT);
  }
  var _useComponentTracking = (0, _useTracking.useComponentTracking)(props),
    tracker = _useComponentTracking.tracker,
    _useComponentTracking2 = _useComponentTracking.result,
    articleTracking = _useComponentTracking2.article,
    reloadTracking = _useComponentTracking2.reload,
    deleteTracking = _useComponentTracking2.delete;
  var getParsedDom = function getParsedDom() {
    var realContent = content.replace(/&amp;/g, '&');
    return domParser.parseFromString("<div id=\"".concat((0, _getPrefixCls.getPrefixCls)('article-content'), "\">").concat(realContent, "</div>"));
  };
  var getArticleRealText = function getArticleRealText() {
    var _dom$getElementById;
    var dom = getParsedDom();
    var realText = '';
    (_dom$getElementById = dom.getElementById((0, _getPrefixCls.getPrefixCls)('article-content'))) === null || _dom$getElementById === void 0 ? void 0 : _dom$getElementById.childNodes.forEach(function (node) {
      if (node.nodeName === 'p') {
        realText += node.textContent;
      }
    });
    return realText;
  };
  var getArticleFirstElement = function getArticleFirstElement() {
    var container = document.createElement('div');
    container.innerHTML = (0, _tools.formatHtml)((0, _sanitizeHtml.default)(content, _sanitizeHtmlOptions.default));
    var firstAccordion = container.querySelector('accordion-block');
    try {
      if (isUIOptimisationAccordion && firstAccordion) {
        var _firstAccordion$getAt, _firstAccordion$getAt2, _accordionList$length;
        var accordionList = JSON.parse(decodeURIComponent((_firstAccordion$getAt = firstAccordion === null || firstAccordion === void 0 ? void 0 : (_firstAccordion$getAt2 = firstAccordion.getAttribute) === null || _firstAccordion$getAt2 === void 0 ? void 0 : _firstAccordion$getAt2.call(firstAccordion, 'data-json')) !== null && _firstAccordion$getAt !== void 0 ? _firstAccordion$getAt : ''));
        setFirstAccordionItemLen((_accordionList$length = accordionList === null || accordionList === void 0 ? void 0 : accordionList.length) !== null && _accordionList$length !== void 0 ? _accordionList$length : 0);
        var reviewAccordionList = accordionList.slice(0, 3);
        firstAccordion === null || firstAccordion === void 0 ? void 0 : firstAccordion.setAttribute('data-json', encodeURIComponent(JSON.stringify(reviewAccordionList)));
      }
    } catch (e) {
      console.log('article parse accordion list error', e);
    }
    var firstImg = container.querySelector('img');
    firstAccordion && firstAccordion.setAttribute('expand', 'false');
    if (firstAccordion && firstImg) {
      if (firstAccordion.compareDocumentPosition(firstImg) & Node.DOCUMENT_POSITION_PRECEDING) {
        return firstImg.outerHTML;
      } else {
        setIsFirstAccordion(true);
        return firstAccordion.outerHTML;
      }
    } else if (firstAccordion) {
      setIsFirstAccordion(true);
      return firstAccordion.outerHTML;
    } else if (firstImg) {
      return firstImg.outerHTML;
    } else {
      return null;
    }
  };
  var onClose = function onClose() {
    setShowArticle(false);
    if (articleContentTrackingData) {
      var trackCloseArticleContentData = trackCloseArticleContentDataRef.current;
      var trackingData = _objectSpread(_objectSpread({}, articleContentTrackingData), {}, {
        view_duration: Math.floor((new Date().getTime() - trackCloseArticleContentData.startTime.getTime()) / 1000),
        article_scrolls: trackCloseArticleContentData.articleScrolls,
        table_scrolls: trackCloseArticleContentData.tableScrolls,
        article_scroll_to_end: trackCloseArticleContentData.articleScrollToEnd ? 0 : 1
      });
      tracker.click({
        trackingsection: _constants2.TRACKING_SECTION[_constants2.TRACKING_TYPE.ARTICLE_DETAIL],
        trackingtarget: _constants2.TRACKING_TARGET.closeArticle,
        data: _objectSpread({}, trackingData)
      });
    }
  };
  var realText = (0, _react.useMemo)(function () {
    return getArticleRealText();
  }, [content]);
  var firstElement = (0, _react.useMemo)(function () {
    return getArticleFirstElement();
  }, [content]);
  var calMaxLines = (0, _react.useMemo)(function () {
    return firstElement ? 1 : 2;
  }, [content]);
  var onClickFaq = function onClickFaq(faq, option) {
    var _props$onClickFaq;
    if (disabledFaq) {
      var _props$onClickDisable;
      (_props$onClickDisable = props.onClickDisabledFaq) === null || _props$onClickDisable === void 0 ? void 0 : _props$onClickDisable.call(props, faq);
      return;
    }
    if (showArticle) {
      setShowArticle(false);
    }
    (_props$onClickFaq = props.onClickFaq) === null || _props$onClickFaq === void 0 ? void 0 : _props$onClickFaq.call(props, faq, option);
  }; // 判断是否为ol/ul元素

  var isListWrapper = function isListWrapper(childElement) {
    return childElement.tagName.toLowerCase() === 'ol' || childElement.tagName.toLowerCase() === 'ul';
  }; // 针对summary预览内容，找出第一个超出已读区域的元素index

  var handleUnread = function handleUnread(richTextElement, gradientOffsetTop, defaultIndex) {
    var childElements = Array.from(richTextElement === null || richTextElement === void 0 ? void 0 : richTextElement.children);
    if (!childElements.length) {
      return;
    } // 如果summary高度没有超出最大高度,unread标签加在末尾

    if (gradientOffsetTop === 0) {
      setUnreadObj({
        index: (childElements === null || childElements === void 0 ? void 0 : childElements.length) - 1
      });
      return;
    }
    for (var i = 0; i < childElements.length; i++) {
      var _childElement$getBoun;
      var childElement = childElements[i]; // 判断子元素底部和父元素顶部之间的距离

      var childHeight = childElement === null || childElement === void 0 ? void 0 : (_childElement$getBoun = childElement.getBoundingClientRect()) === null || _childElement$getBoun === void 0 ? void 0 : _childElement$getBoun.height;
      var distance = childHeight + childElement.offsetTop; // 已读内容高度是指白色渐变顶部距离父元素顶部的距离

      if (distance > gradientOffsetTop) {
        // 如果第一个超出已读部分的刚好是ol/ul标签，需要再深入一层判断其中具体的子元素
        if (isListWrapper(childElement)) {
          handleUnread(childElement, gradientOffsetTop, i);
        } else {
          // 其他元素直接获得index
          setUnreadObj({
            index: defaultIndex !== undefined ? defaultIndex : i,
            listIndex: defaultIndex !== undefined ? i : undefined
          });
        }
        break;
      }
    }
  };
  var getUIOptimisationAccordionOptions = function getUIOptimisationAccordionOptions(html) {
    if (isUIOptimisationAccordion) {
      return {
        html: html,
        expand: false,
        isUIOptimisationAccordion: isUIOptimisationAccordion,
        onUIOptimisationAccordionClick: function onUIOptimisationAccordionClick(accordionItemIndex, accordionIndex) {
          setUIOptimisationAccordionOptions({
            accordionItemIndex: accordionItemIndex,
            accordionIndex: accordionIndex
          });
          setShowArticle(true);
        }
      };
    } else {
      return undefined;
    }
  };
  (0, _react.useEffect)(function () {
    if (!showArticle) {
      setUIOptimisationAccordionOptions({
        accordionItemIndex: -1,
        accordionIndex: -1
      });
    }
  }, [showArticle]);
  (0, _react.useEffect)(function () {
    setTimeout(function () {
      if (isOldUI) {
        return;
      }
      var ResizeObserver = window.ResizeObserver || _resizeObserver.ResizeObserver;
      var resizeObserver = new ResizeObserver(function (entries) {
        var _iterator = _createForOfIteratorHelper(entries),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var entry = _step.value;
            var contentRect = entry.contentRect;
            if (!contentRect.height) {
              return;
            }
            var richTextElement = summaryRef.current.querySelector('.ChatbotUI-rich-text-content');
            if (Math.round(contentRect.height) >= summaryMaxHeight - 12) {
              setExceededMaxHeight(true);
              onExceededMaxHeightChange === null || onExceededMaxHeightChange === void 0 ? void 0 : onExceededMaxHeightChange(true); // 白色渐变顶部距离父元素顶部的距离

              var gradientOffsetTop = summaryMaxHeight - 40; // 在预览状态下确认已读区域

              isScrollToUnread && handleUnread(richTextElement, gradientOffsetTop);
            } else {
              setExceededMaxHeight(false);
              onExceededMaxHeightChange === null || onExceededMaxHeightChange === void 0 ? void 0 : onExceededMaxHeightChange(false); // 如果summary高度没有超出最大高度,unread标签加在末尾

              isScrollToUnread && handleUnread(richTextElement, 0);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
      summaryRef.current && resizeObserver.observe(summaryRef.current);
      return function () {
        resizeObserver.disconnect();
      };
    }, 500);
  }, []);
  (0, _react.useEffect)(function () {
    if (isOldUI && autoPopup && !showArticle) {
      setTimeout(function () {
        setShowArticle(true);
      }, 0);
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (!isOldUI && needPopup && !showArticle && exceededMaxHeight) {
      setTimeout(function () {
        setShowArticle(true);
      }, 500);
    }
  }, [exceededMaxHeight]);
  var renderLoadingArticle = function renderLoadingArticle() {
    var _ComponentStatusMappi;
    var NetworkError = /*#__PURE__*/_react.default.createElement("div", reloadTracking === null || reloadTracking === void 0 ? void 0 : reloadTracking.trackingImpressionProps, /*#__PURE__*/_react.default.createElement("img", {
      className: (0, _clsx4.default)((0, _getPrefixCls.getPrefixCls)('article__error-image')),
      src: _fail_to_load.default
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx4.default)((0, _getPrefixCls.getPrefixCls)('article__error-prompt'))
    }, failToLoadText, /*#__PURE__*/_react.default.createElement("a", {
      onClick: function onClick() {
        var _props$reloadArticle;
        (reloadTracking === null || reloadTracking === void 0 ? void 0 : reloadTracking.trackingClick) && tracker.click(reloadTracking.trackingClick);
        props === null || props === void 0 ? void 0 : (_props$reloadArticle = props.reloadArticle) === null || _props$reloadArticle === void 0 ? void 0 : _props$reloadArticle.call(props);
      }
    }, reloadText)));
    var Loading = /*#__PURE__*/_react.default.createElement("img", {
      src: _loading_circle.default,
      className: (0, _clsx4.default)((0, _getPrefixCls.getPrefixCls)('article__loading-icon'))
    });
    var ArticleIsDeleted = /*#__PURE__*/_react.default.createElement("div", deleteTracking === null || deleteTracking === void 0 ? void 0 : deleteTracking.trackingImpressionProps, /*#__PURE__*/_react.default.createElement("img", {
      className: (0, _clsx4.default)((0, _getPrefixCls.getPrefixCls)('article__error-image')),
      src: _fail_to_load.default
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx4.default)((0, _getPrefixCls.getPrefixCls)('article__error-prompt'))
    }, articleDeletedText));
    var ComponentStatusMapping = (_ComponentStatusMappi = {}, (0, _defineProperty2.default)(_ComponentStatusMappi, ArticleStatus.ERROR, NetworkError), (0, _defineProperty2.default)(_ComponentStatusMappi, ArticleStatus.LOADING, Loading), (0, _defineProperty2.default)(_ComponentStatusMappi, ArticleStatus.DELETED, ArticleIsDeleted), (0, _defineProperty2.default)(_ComponentStatusMappi, ArticleStatus.FINISH, null), _ComponentStatusMappi);
    return ComponentStatusMapping[status] || NetworkError;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx4.default)((0, _getPrefixCls.getPrefixCls)('article'))
  }, isOldUI ? /*#__PURE__*/_react.default.createElement("div", null, status === ArticleStatus.FINISH ? /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _clsx4.default)((0, _getPrefixCls.getPrefixCls)('article-content') // isUIOptimisationButton && getPrefixCls('ui-optimisation-accordion-article-content')
    )
  }, articleTracking === null || articleTracking === void 0 ? void 0 : articleTracking.trackingImpressionProps), /*#__PURE__*/_react.default.createElement(_Title.Title, {
    className: (0, _getPrefixCls.getPrefixCls)('article-title'),
    content: title
  }), /*#__PURE__*/_react.default.createElement(_Text.Text, {
    className: (0, _getPrefixCls.getPrefixCls)('article-desc'),
    content: realText,
    maxLines: calMaxLines
  }), firstElement && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_RichText.RichText, {
    content: firstElement,
    className: (0, _clsx4.default)((0, _getPrefixCls.getPrefixCls)('article-first-element'), (0, _defineProperty2.default)({}, (0, _getPrefixCls.getPrefixCls)('ui-optimisation-accordion'), isUIOptimisationAccordion && isFirstAccordion)),
    uiOptimisationAccordionOptions: getUIOptimisationAccordionOptions(firstElement),
    isUIOptimisationButton: isUIOptimisationButton,
    isUIOptimisationTableReview: isUIOptimisationTable
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx4.default)((0, _getPrefixCls.getPrefixCls)('article-gradient'), (0, _getPrefixCls.getPrefixCls)('article-gradient-bottom'), (0, _defineProperty2.default)({}, (0, _getPrefixCls.getPrefixCls)('article-gradient__show'), firstAccordionUIOptimisation && isFirstAccordion || !isFirstAccordion))
  }))) : /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _getPrefixCls.getPrefixCls)("article__".concat(status.toLowerCase()))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _getPrefixCls.getPrefixCls)('article-content')
  }, renderLoadingArticle())), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    disabled: status !== ArticleStatus.FINISH,
    action: {
      func: 'showArticle'
    },
    text: showButtonText || trans(_constants.VIEW_ARTICLE_TEXT),
    onClick: function onClick() {
      (articleTracking === null || articleTracking === void 0 ? void 0 : articleTracking.trackingClick) && tracker.click(articleTracking.trackingClick);
      setShowArticle(!showArticle);
    }
  })) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    ref: summaryRef,
    className: (0, _clsx4.default)((0, _getPrefixCls.getPrefixCls)('article-summary')),
    style: {
      maxHeight: summaryMaxHeight
    }
  }, /*#__PURE__*/_react.default.createElement(_RichText.RichText, {
    content: content,
    uiOptimisationAccordionOptions: getUIOptimisationAccordionOptions(content),
    isUIOptimisationButton: isUIOptimisationButton,
    isUIOptimisationTableReview: isUIOptimisationTable
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx4.default)((0, _getPrefixCls.getPrefixCls)('article-gradient'), (0, _defineProperty2.default)({}, (0, _getPrefixCls.getPrefixCls)('article-gradient__show'), exceededMaxHeight))
  })), exceededMaxHeight && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _getPrefixCls.getPrefixCls)('article-btn'),
    onClick: function onClick() {
      (articleTracking === null || articleTracking === void 0 ? void 0 : articleTracking.trackingClick) && tracker.click(articleTracking.trackingClick);
      setShowArticle(!showArticle);
    }
  }, /*#__PURE__*/_react.default.createElement("span", null, viewMoreText), /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
    src: _key_answer_arrow.default,
    className: (0, _getPrefixCls.getPrefixCls)('article-arrow')
  }))), /*#__PURE__*/_react.default.createElement(_PopupArticle.PopupArticle, {
    className: popupClassName,
    active: showArticle,
    title: title,
    content: content,
    closeButtonText: closeButtonText,
    onClose: onClose,
    changeTrackCloseArticleContentData: changeTrackCloseArticleContentData,
    articleContentTrackingData: articleContentTrackingData,
    disableSpecialLink: disableSpecialLink,
    showExpandIcon: showExpandIcon,
    unreadObj: unreadObj,
    isScrollToUnread: isScrollToUnread,
    unreadText: unreadText,
    exceededMaxHeight: exceededMaxHeight,
    isSeparate: isSeparate,
    disabledFaq: disabledFaq,
    faqTitle: faqTitle,
    faqIntentList: faqIntentList,
    onClickFaq: onClickFaq,
    trackingData: (_props$componentTrack = props.componentTrackingData) === null || _props$componentTrack === void 0 ? void 0 : _props$componentTrack.faq,
    isOldUI: isOldUI,
    useUIOptimisationRecommender: useUIOptimisationRecommender,
    isUIOptimisationAccordion: isUIOptimisationAccordion,
    uiOptimisationAccordionOptions: uiOptimisationAccordionOptions,
    isUIOptimisationButton: isUIOptimisationButton,
    isUIOptimisationTable: isUIOptimisationTable
  }));
};
exports.Article = Article;